export default __webpack_public_path__ + "static/media/07.e4f309a0.jpg";